export default {
  meta: {
    title: '门店管理',
  },
};
